import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};
import Navbar from "./components/Navbar";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import TheFirm from "./pages/TheFirm";
import WhatWeDo from "./pages/WhatWeDo";
import BoardOfDirectors from "./pages/BoardOfDirectors";
import InvestorInfo from "./pages/InvestorInfo";
import InvestmentSectors from "./pages/InvestmentSectors";
import OurSubsidiaries from "./pages/OurSubsidiaries";
import Careers from "./pages/Careers";
import usePageMeta from "./hooks/usePageMeta";

const ContactPage = () => {
  usePageMeta(
    "Contact",
    "Get in touch with Fundviser Capital (India) Ltd. — Mumbai-based, BSE-listed (530197) investment company."
  );
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <ContactSection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/the-firm" element={<TheFirm />} />
          <Route path="/what-we-do" element={<WhatWeDo />} />
          <Route path="/board-of-directors" element={<BoardOfDirectors />} />
          <Route path="/investor-info" element={<InvestorInfo />} />
          <Route path="/investment-sectors" element={<InvestmentSectors />} />
          <Route path="/our-subsidiaries" element={<OurSubsidiaries />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/careers" element={<Careers />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
